import vuetify from "@/main";
import InvoiceEmail from '../../settings/company/InvoiceEmail/InvoiceEmail.vue';
import InvoiceEmailActivity from '../../settings/company/InvoiceEmailActivity/EmailActivity.vue';
angular.module('leanlaw').config(['$stateProvider', $stateProvider => {
  $stateProvider.state('billing.delivery', {
    url: "/delivery",
    template: "<div ui-view></div>"
  }).state('billing.invoiceEmail', {
    url: "/invoiceEmail",
    views: {
      '': {
        ...vuetify(InvoiceEmail)
      }
    }
  }).state('billing.invoiceEmailActivity', {
    url: "/invoiceEmailActivity",
    views: {
      '': {
        ...vuetify(InvoiceEmailActivity)
      }
    },
    params: {
      emailLogId: undefined
    }
  });
}]);